var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRules(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_464_333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9968 1.46625H4.39884C4.00997 1.46625 3.63703 1.62072 3.36206 1.89569C3.08709 2.17066 2.93262 2.5436 2.93262 2.93247V14.6622C2.93262 15.0511 3.08709 15.424 3.36206 15.699C3.63703 15.974 4.00997 16.1285 4.39884 16.1285H13.1962C13.585 16.1285 13.958 15.974 14.2329 15.699C14.5079 15.424 14.6624 15.0511 14.6624 14.6622V5.1318L10.9968 1.46625Z",
    strokeWidth: 1.46622,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2637 1.46625V4.39869C10.2637 4.78756 10.4181 5.16049 10.6931 5.43546C10.9681 5.71043 11.341 5.86491 11.7299 5.86491H14.6623",
    strokeWidth: 1.46622,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33146 6.59802H5.86523",
    strokeWidth: 1.46622,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7301 9.53046H5.86523",
    strokeWidth: 1.46622,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7301 12.4629H5.86523",
    strokeWidth: 1.46622,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_464_333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5947,
    height: 17.5947,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRules);
export default __webpack_public_path__ + "static/media/rules.442269be383ea0c5fef60a9ea35c956c.svg";
export { ForwardRef as ReactComponent };